import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 2.68rem;
  display: flex;
  background-color: #585e66;
  margin-top: 1.2rem;

  box-shadow: 0px 5.62941px 11.2588px rgba(88, 94, 102, 0.08);
  border-radius: 4.22206px;

  font-family: 'Sora';
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;

  justify-content: center;
  align-items: center;

  color: #eff1f5;
`;
